import NavigationBarControl from '../../../lib/ui/NavigationBarControl'

export default class New {
  constructor (element) {
    let fragment = document.createDocumentFragment()
    new NavigationBarControl(fragment, {
      title: 'Nieuw',
      leftHandButtons: [{
        onclick: () => {
          history.back()
        },
        icon: '\ue00d'
      },
        {
          onclick: () => {
            history.forward()
          },
          icon: '\ue01a'
        },
        {
          onclick: () => {
            window.PRIM.navigate('/start/')
          },
          icon: '\ue08a'
        }]
    })

    let div = document.createElement('div')
    div.className = 'viewport'

    let a1 = document.createElement('a')
    a1.className = 'icon button'
    a1.innerHTML = 'Persoon'
    a1.onclick = () => {
      window.PRIM.navigate('/people/')
    }
    let span1 = document.createElement('span')
    span1.innerHTML = '\ue12c'
    a1.insertBefore(span1, a1.childNodes[0])

    let a2 = document.createElement('a')
    a2.className = 'icon button'
    a2.innerHTML = 'Organisatie'
    a2.onclick = () => {
      window.PRIM.navigate('/organisations/')
    }
    let span2 = document.createElement('span')
    span2.innerHTML = '\ue078'
    a2.insertBefore(span2, a2.childNodes[0])

    /*let a3 = document.createElement('a')
    a3.className = 'icon button'
    a3.innerHTML = 'Bestand'
    a3.onclick = () => {
      window.PRIM.navigate('/files/')
    }
    let span3 = document.createElement('span')
    span3.innerHTML = '\ue063'
    a3.insertBefore(span3, a3.childNodes[0])*/

    div.appendChild(a1)
    div.appendChild(a2)
    //div.appendChild(a3)

    fragment.appendChild(div)

    element.appendChild(fragment)
  }
}



// WEBPACK FOOTER //
// ./js/modules/start/action/New.js